import { IconButton } from "@mui/material";
import clsx from "clsx";
import dialogStyles from "../dialogStyles.module.css";

const monthIcon: { [key: string]: string } = {
  "1": "Ⅰ",
  "2": "Ⅱ",
  "3": "Ⅲ",
  "4": "Ⅳ",
  "5": "Ⅴ",
  "6": "Ⅵ",
  "7": "Ⅶ",
  "8": "Ⅷ",
  "9": "Ⅸ",
  "10": "Ⅹ",
  "11": "Ⅺ",
  "12": "Ⅻ",
};
interface Props {
  title: string;
  id: string;
  onClick: (id: string) => void;
}

export default function MonthButton({ title, id, onClick }: Props) {
  return (
    <IconButton
      title={title}
      className={clsx(dialogStyles.dialogCalendarMonthButton)}
      size="small"
      onClick={() => {
        onClick(id);
      }}
    >
      {monthIcon[id] || ""}
    </IconButton>
  );
}
